"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgInstantConfirm(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 18 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.6083 1.39813L11.5259 0.327187L2.6914 16.2952L3.76912 17.3759L7.71278 17.0074L7.72609 19.6847L6.68582 26.6305L7.76602 27.7164L16.2615 10.9218L15.1832 9.84868L12.6566 11.2263L12.6083 1.39813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.528 0.324326L2.68885 16.3021L6.63252 15.9336L6.68576 26.6426L15.1813 9.84803L11.5763 10.1525L11.528 0.324326Z",
    fill: "url(#paint0_linear_987_29994)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_987_29994",
    x1: "7.08685",
    y1: "0.996001",
    x2: "10.8699",
    y2: "26.0098",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    "stop-color": "#2080F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    "stop-color": "#5BC9F5"
  }))));
}

var MemoSvgInstantConfirm = /*#__PURE__*/React.memo(SvgInstantConfirm);
var _default = MemoSvgInstantConfirm;
exports["default"] = _default;